/**
 *
 * Address
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Form } from 'react-bootstrap';
import classNames from 'classnames';
import produce from 'immer';
import { object, string } from 'yup';
import FormControlWrapper from 'components/interaction/Form4/FormControlWrapper.jsx';
import messages from './messages.js';
import MultiInput from '../MultiInput/index.jsx';

const unRequire = produce((draft) => {
  draft.attributes.required = false;
});

const items = [
  { id: 'street', label: messages.street, attributes: { maxLength: 100, required: true } },
  { id: 'streetNumber', label: messages.streetNumber, attributes: { maxLength: 10, required: true } },
  { id: 'streetNumberAdd', label: messages.streetNumberAdd, attributes: { maxLength: 20 } },
  { id: 'postalCode', label: messages.postalCode, attributes: { maxLength: 20, required: true } },
  { id: 'city', label: messages.city, attributes: { maxLength: 50, required: true } },
];

const itemsSingleStreet = items.filter((o) => !o.id.startsWith('streetNumber'));

const KEYS = items.map((item) => item.id);

const Wrapper = styled(Form.Group)`
  & > * {
    flex: 0 0 100%;
    margin-bottom: 15px;
  }
  @media (min-width: ${(p) => p.theme.screenSmMin}) {
    display: flex;
    flex-wrap: wrap;
    & > #streetNumber,
    & > #streetNumberAdd,
    & > #postalCode {
      flex: 0 0 calc(35% - 10px);
      min-width: 6em;
      margin-right: 10px;
    }
    & > #postalCode {
      min-width: 6em;
    }
    & > #city {
      flex: 1 1 50%;
    }
  }
`;

function Address(props) {
  const { singleStreet, required, className, ...rest } = props;
  // eslint-disable-next-line react/destructuring-assignment
  const notRequired = required === false && MultiInput.isEmpty(KEYS)(props.value);
  const itemsWithRequired = (singleStreet ? itemsSingleStreet : items)
    .map((item) => notRequired ? unRequire(item) : item);
  const classList = classNames(['w-100', className]);
  return (
    <FormControlWrapper className={classList} border={2}>
      <Wrapper>
        <MultiInput items={itemsWithRequired} {...rest} />
      </Wrapper>
    </FormControlWrapper>
  );
}

Address.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  singleStreet: PropTypes.bool,
  required: PropTypes.bool,
  value: PropTypes.object,
};

Address.propTypes = {
  required: PropTypes.bool,
};

Address.itemToString = addressToString;
Address.isEmpty = MultiInput.isEmpty(KEYS);

function addressToString(address) {
  if (Address.isEmpty(address)) {
    return '';
  }
  return [address.street, (address.streetNumber || '') + (address.streetNumberAdd || ''), ',', address.postalCode, address.city]
    .filter((str) => Boolean(str)).join(' ').replace(' ,', ',');
}

export function addressParser(o) {
  const { street, streetNumber, streetNumberAdd, postalCode, city, ...rest } = o;
  return { ...rest, value: { street, streetNumber, streetNumberAdd, postalCode, city } };
}

Address.getSchema = (options, intl) => {
  const { required, attributes } = options;
  const requiredString = () => required ? string().required() : string();
  return object().shape({
    street: requiredString().label(intl.formatMessage(messages.street)),
    streetNumber: attributes?.singleStreet ? string().nullable() : requiredString().label(intl.formatMessage(messages.streetNumber)),
    streetNumberAdd: string().nullable(),
    postalCode: requiredString().label(intl.formatMessage(messages.postalCode)),
    city: requiredString().label(intl.formatMessage(messages.city)),
  });
};
export default Address;
